<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card v-else-if="!this.loading && !this.errormessage">
      <el-table
        :data="rowData"
        header-row-class-name="text-danger"
        size="small"
        :header-cell-style="headerCellStyle"
        :default-sort="sorting"
        :cell-style="cellStyle"
        @cell-click="onCellClick"
        v-if="rowData && rowData.length > 0"
      >
        <el-table-column
          label="Name"
          label-class-name="text-danger"
          class-name="text-primary pointer column50"
        >
          <template slot-scope="props">
            {{ getMobileName(props) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Patrol"
          property="CritterName"
          class-name="d-none d-md-table-cell text-center"
        />
        <el-table-column
          class-name="d-none d-md-table-cell text-center"
          label="Ticket Counselor"
          width="125"
          property="TicketCounselorScouterKey"
          :formatter="ticketCounselorName"
        />
        <el-table-column
          label="Goals"
          class-name="text-center column50"
        >
          <template slot-scope="props">
            <div class="row">
              <div
                class="p-0 col text-center border border-white"
                style="line-height:1.2em;"
                :class="statuses[props.row['Goal1']].badgeClass"
                :title="statuses[props.row['Goal1']].badgeToolTip"
              >
                {{ statuses[props.row['Goal1']].badge }}
              </div>
              <div
                class="p-0 col text-center border border-white"
                style="line-height:1.2em;"
                :class="statuses[props.row['Goal2']].badgeClass"
                :title="statuses[props.row['Goal2']].badgeToolTip"
              >
                {{ statuses[props.row['Goal2']].badge }}
              </div>
              <div
                class="p-0 col text-center border border-white"
                style="line-height:1.2em;"
                :class="statuses[props.row['Goal3']].badgeClass"
                :title="statuses[props.row['Goal3']].badgeToolTip"
              >
                {{ statuses[props.row['Goal3']].badge }}
              </div>
              <div
                class="p-0 col text-center border border-white"
                style="line-height:1.2em;"
                :class="statuses[props.row['Goal4']].badgeClass"
                :title="statuses[props.row['Goal4']].badgeToolTip"
              >
                {{ statuses[props.row['Goal4']].badge }}
              </div>
              <div
                class="p-0 col text-center border border-white"
                style="line-height:1.2em;"
                :class="statuses[props.row['Goal5']].badgeClass"
                :title="statuses[props.row['Goal5']].badgeToolTip"
              >
                {{ statuses[props.row['Goal5']].badge }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          label="Assign"
        >
          <template slot-scope="props">
            <p-button
              type="success"
              class="mt-1 mb-1"
              size="sm"
              title="Assign Ticket Counselor"
              icon
              @click="assign(props.row)"
            >
              <i class="ti ti-receipt" />
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <modal
      :show.sync="showEdit"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="ti ti-receipt mr-2" /><span class="text-danger">Assign Ticket Counselor to Participant</span>
        </h6>
      </div>
      <ValidationObserver ref="form">
        <form @submit.prevent="validate">
          <div class="row">
            <div class="col-12">
              <ValidationProvider
                name="ticketCounselor"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <fg-input>
                  <label>Please select a Ticket Counselor</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    :error="failed ? 'Please select a Ticket Counselor' : null"
                    :has-success="passed"
                    name="ticketCounselor"
                    placeholder=""
                    v-model="counselorUpdate.TicketCounselorScouterKey"
                  >
                    <el-option
                      v-for="(data, index) in staff"
                      class="select-default2"
                      :value="index"
                      :label="data"
                      :key="data"
                    />
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEdit = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="save"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import ticketStatusApi from '@/services/api/ticket-status'
import ticketApi from '@/services/api/ticket'
import scouterApi from '@/services/api/scouter'
import oops from '@/components/_main/oops.vue'
import ticketGoalStatuses from '@/services/static/ticket-goal-statuses'

import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'TicketCounselorEdit',
  components: {
    oops,
    Modal
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      sorting: { prop: 'CritterName' },
      rowData: null,
      statuses: null,
      loading: true,
      errormessage: null,
      staff: null,
      showEdit: false,
      counselorUpdate: {},
      tempHolding: null
    }
  },
  created () {
    this.statuses = ticketGoalStatuses.getStatuses()
  },
  mounted () {
    this.setStaffInfo()
  },
  methods: {
    assign: function (row) {
      this.counselorUpdate = row
      this.showEdit = true
    },
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.save()
        return res
      })
    },
    getMobileName: function (props) {
      if (props.column.realWidth > 150) {
        return props.row.ScouterName
      } else {
        const nm = props.row.ScouterName.trim().split(' ')
        if (nm.length > 1) {
          return nm[0] + ' ' + nm[1][0] + '.'
        } else {
          return props.row.ScouterName
        }
      }
    },
    save: function () {
      this.updateTicketCounselor(
        this.counselorUpdate.ScouterKey,
        this.counselorUpdate.TicketCounselorScouterKey
      )
      this.showEdit = false
    },
    ticketCounselorName: function (row, column, cellValue, index) {
      if (cellValue) {
        return this.staff[cellValue]
      } else {
        return null
      }
    },
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Name') {
        const path = '/staff/participant-ticket?s=' + row.ScouterKey + '&r=tick-edit'
        this.$router.push(path)
      }
    },
    setTicketStatusInfo: function () {
      ticketStatusApi
        .listParticipantStatus(this.$root.courseKey)
        .then(x => {
          this.rowData = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    setStaffInfo: function () {
      scouterApi
        .getStaffLookups(this.$root.courseKey, false)
        .then(x => {
          this.staff = x
          this.setTicketStatusInfo()
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateTicketCounselor: function (scouterKey, counselorScouterKey) {
      ticketApi
        .updateTicketCounselor(scouterKey, counselorScouterKey)
        .then(() => {
          this.$notify({
            message: 'The ticket counselor assignment is complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your ticket counselor.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
